import { authenticatedGet, authenticatedPost } from "./util/api";
import { sha256Hex } from "./util/sha256";
import { showError, showSuccess } from "./util/alerts";
import { appNavigate, currentLocation } from "./navigation";
import StoreHandler from "../base/store";
import * as Sentry from "@sentry/react";
import {
  LOGIN_FAIL,
  LOGIN_FETCH,
  LOGIN_SUCCESS,
  SET_LOCALE,
  SET_PROFILE,
} from "./userActions.constants";

export function login(email, password) {
  return async (dispatch) => {
    dispatch({
      type: LOGIN_FETCH,
    });
    return authenticatedPost("user/login", {
      email,
      password: await sha256Hex(password),
    })
      .then((user) => {
        Sentry.setUser(user);
        dispatch({
          type: LOGIN_SUCCESS,
          user,
        });
        dispatch(loadLocale());
        const params = new URLSearchParams(currentLocation().search);
        if (params.has("from")) {
          appNavigate(decodeURIComponent(params.get("from")));
        } else {
          appNavigate("/dashboard");
        }
        return Promise.resolve(user);
      })
      .catch((msg) => {
        dispatch({ type: LOGIN_FAIL });
        return showError(msg.message);
      });
  };
}

export function logout() {
  return (dispatch) => {
    return authenticatedGet("user/logout").then((msg) => {
      Sentry.setUser(null);
      document.cookie = "PLAY_LANG=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      document.cookie = "PLAY_SESSION=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      dispatch({
        type: "LOGOUT",
      });
      dispatch(loadLocale());
      return Promise.resolve(msg);
    });
  };
}

export function restoreSession() {
  return (dispatch) => {
    return authenticatedGet("user/ping").then((user) => {
      console.log("Restored login state.");
      dispatch({
        type: "LOGIN_SUCCESS",
        user,
      });
      dispatch(loadLocale());
      return Promise.resolve(user);
    });
  };
}

const loggedIn = () => StoreHandler.store.getState().user.email;

export const setLocale = (locale) => {
  return (dispatch) => {
    dispatch({
      type: SET_LOCALE,
      locale,
    });

    if (!loggedIn()) {
      return;
    }

    authenticatedPost("user/language", {
      language: locale,
    })
      .then(() => {})
      .catch((msg) => showError(msg.message));
  };
};

export const loadLocale = () => {
  return (dispatch) => {
    if (!loggedIn()) {
      return;
    }

    authenticatedGet("user/language")
      .then((locale) =>
        dispatch({
          type: SET_LOCALE,
          locale: locale.language,
        }),
      )
      .catch((msg) => showError(msg.message));
  };
};

export const requestPasswordReset = (email) => (dispatch) => {
  return authenticatedPost("user/passwordReset/request?email=" + email);
};

export const checkPasswordResetToken = (token) => (dispatch) => {
  return authenticatedGet("user/passwordReset/check?token=" + token);
};

export const performPasswordReset = (token, password) => async (dispatch) => {
  const hashed = await sha256Hex(password);
  return authenticatedPost(
    `user/passwordReset/set?token=${token}&password=${hashed}`,
  );
};

export const updatePassword = (password) => async (dispatch) => {
  return authenticatedPost("user/password", {
    password: await sha256Hex(password),
  })
    .then((msg) => showSuccess(msg.message))
    .catch((err) => showError(err.message));
};

export const updateProfile = (profile) => (dispatch) => {
  return authenticatedPost("user/profile", profile)
    .then((msg) => showSuccess(msg.message))
    .then(
      dispatch({
        type: SET_PROFILE,
        profile,
      }),
    )
    .catch((err) => showError(err.message));
};
